export function* iterFilter<T>(iterable: Iterable<T>, filterFunc: (item: T) => boolean) {
  for (const item of iterable) {
    if (filterFunc(item)) {
      yield item;
    }
  }
}
export function* iterFlatMap<In, Out>(iterable: Iterable<In>, mapFunc: (item: In) => Array<Out>): Iterable<Out> {
  for (const item of iterable) {
    yield* mapFunc(item);
  }
}
export function* iterMap<In, Out>(iterable: Iterable<In>, mapFunc: (item: In) => Out): Iterable<Out> {
  for (const item of iterable) {
    yield mapFunc(item);
  }
}
export function* toEntries<T>(iterable: Iterable<T>): Iterable<[number, T]> {
  let index = 0;
  for (const item of iterable) {
    yield [index, item];
    index++;
  }
}